import { render, staticRenderFns } from "./workersSelection.vue?vue&type=template&id=7b524c9d&scoped=true&"
import script from "./workersSelection.vue?vue&type=script&lang=js&"
export * from "./workersSelection.vue?vue&type=script&lang=js&"
import style0 from "./workersSelection.vue?vue&type=style&index=0&id=7b524c9d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b524c9d",
  null
  
)

export default component.exports